import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'

/**
 * Handles standardized TOTP API error responses and updates modal state or toasts.
 * @param {Object} params
 * @param {number} params.status - HTTP error status code
 * @param {string} params.metaMessage - Error message from backend
 * @param {Object} [params.helpers] - Control helper methods from ModalTOTP
 * @param {number} params.totpAttempts - Total failed attempts count
 * @param {Function} params.toast - Toast notification handler
 * @param {number} [params.maxAttempts=3] - Maximum allowed TOTP attempts
 */
// eslint-disable-next-line import/prefer-default-export
export const handleDefaultResponse = ({
  status, metaMessage, helpers, totpAttempts, toast, maxAttempts = 3,
}) => {
  if (
    status === 429
          || metaMessage === 'authenticator blocked for 24 hours after three failed attempts'
  ) {
    if (helpers) {
      if (totpAttempts >= maxAttempts) {
        helpers.setBlocked()
      } else {
        helpers.setBlocked('restricted')
      }
    }
    return
  }

  if (metaMessage === 'authenticator not configured') {
    if (helpers) helpers.setError('Authenticator belum dikonfigurasi.')
    return
  }

  if (status === 400) {
    if (helpers) {
      const remaining = Math.max(1, maxAttempts - totpAttempts)
      helpers.setError('Kode OTP Salah. Silahkan cek kembali kode OTP Anda.', remaining)
    }
    return
  }

  if (status === 422) {
    if (helpers) helpers.setError('Format Kode OTP tidak sesuai. Pastikan terdiri dari 6 digit angka.')
    return
  }

  if (status === 503) {
    if (helpers) helpers.setError('Layanan authenticator tidak tersedia. Silahkan coba beberapa menit lagi.')
  }

  if (helpers) {
    helpers.setError(metaMessage)
  } else {
    toast(
      {
        component: ToastificationContentVue,
        props: {
          title: 'Failure',
          icon: 'AlertCircleIcon',
          text: metaMessage || 'Terjadi kesalahan tak terduga, silahkan coba kembali beberapa menit lagi',
          variant: 'danger',
        },
      },
      2000,
    )
  }
}
